import { fansupportPublic } from "./index";

export const getTeams = async ({sportId, countryId, tournamentId}) => {
    return fansupportPublic.get('/sport/filter',{ params: { 
        sportId,
        countryId,
        tournamentId, 
    }})
} 